import { useMediaQuery } from "react-responsive";
import LogoPic from "../assets/header.png"
import "./Header.css"
import NavBar from "./navBar";
import { useContext, useEffect, useState } from "react";
import { SearcgContext } from "./SearchContext";
import { loginkey } from "./LoginContext";
import { AddDetailsContext } from "./AddDetailsContext";
import { NavContext } from "./NavContext";
import Logo from '../assets/companyLogo2.png';
import React from "react";
import { BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MdTranslate } from "react-icons/md";
import { loginOrRegister } from "./LoginOrRegisterContext";
import { AiOutlineMenu } from "react-icons/ai";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";

function Header() {
    const { setSearch } = useContext(SearcgContext);
    const { auth } = useContext(loginkey);
    const { setAuth } = useContext(loginkey);
    const [a, setA] = useState("")
    const [d, setD] = useState("")
    const [arbLangLink, setArbLangLink] = useState("https://drclinic.hassan-mohammad.tech")
    const [engLangLink, setEngLangLink] = useState("https://drclinic.hassan-mohammad.tech")
    const { addDetailsContextt } = useContext(AddDetailsContext);
    const { setAddDetailsContextt } = useContext(AddDetailsContext);
    const { logged } = useContext(loginOrRegister)
    const { setLogged } = useContext(loginOrRegister)
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    const handleSearch = (e) => {
        setSearch(e.target.value);
    }
    const navigate = useNavigate();
    function handleLogout() {
        setAuth(0);
        navigate("/", { replace: true });
    }
    function handleServecesNav() {
        setAuth(0);
        navigate("/OurServeces", { replace: true });
    }
    function handleDeleteAccount() {
        setAuth(0);
        navigate("/DeleteAccount", { replace: true });
    }
    function handleLoginNav() {
        setAuth(0);
        navigate("/", { replace: true });
    }
    function handleContactUsNav() {
        setAuth(0);
        navigate("/ContactUs", { replace: true });
    }
    /* useEffect(() => {
         if (auth === 0) {
             setAuth(window.localStorage.getItem("auth"))
             setAddDetailsContextt(window.localStorage.getItem("details"))
             console.log(`auth ${window.localStorage.getItem("auth")}`);
             console.log(`details ${window.localStorage.getItem("details")}`);
         }
     }, [])
     useEffect(() => {
             window.localStorage.setItem("auth", auth);
             console.log(`auth from 1111 ${auth}`)
             window.localStorage.setItem("details", addDetailsContextt);
     }, [addDetailsContextt])*/

    const loginRegister = () => {
        setLogged(!logged)
        handleLoginNav()
    }

    return (
        <div>
            {isDesktopOrLaptop && <header className="header-container">
                <div className="header-search">
                    <img src={Logo} alt="logo-img" className="logo"></img>
                    {auth === 1 && <button className="btn" onClick={handleLogout}><BiLogOut color="gray" size={32} /></button>}
                </div>
                {auth === 0 && <div className="title-container">
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline-danger" onClick={handleDeleteAccount}>Delete my account</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline-primary" onClick={handleContactUsNav}>Contact Us</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline-primary" onClick={handleServecesNav}>Our Services</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {logged && <button className="btn btn-outline-primary" onClick={loginRegister}>Login</button>}
                        {!logged && <button className="btn btn-outline-primary" onClick={loginRegister}>Register</button>}
                    </div>
                    {auth == 0 && <img src={LogoPic} alt="logoPic-img" className="logoPic-img"></img>}
                    {/*auth === 0 &&<div className="language">
                        <div className="dropdown">
                            <a className="btn btn-secondary dropdown-toggle" href={arbLangLink} role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <MdTranslate/>
                            </a>

                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href={arbLangLink}>Arabic</a></li>
                                <li><a className="dropdown-item" href={engLangLink}>English</a></li>
                            </ul>
                        </div>
                    </div>*/}
                    {/*<div className="title">C l i n i c</div>*/}
                </div>}
                {auth == 1 && !addDetailsContextt && <NavBar />}
            </header>}
            {isTabletOrMobile && <header className="header-container-mobile">
                <div className="header-search">
                    <img src={Logo} alt="logo-img-mobile" className="logo"></img>
                    {auth === 1 && <button className="btn" onClick={handleLogout}><BiLogOut color="gray" size={32} /></button>}
                </div>
                {auth == 0 && <nav className="nav-list-mobile">
                    <Menu menuButton={<MenuButton className="m-btn"><AiOutlineMenu color='white' size={35} /></MenuButton>}>
                    <MenuItem className="menu-nav" style={{ backgroundColor: 'black' }}>
                            <a onClick={handleDeleteAccount} className="list-item">Delete account</a>
                        </MenuItem>
                        <MenuItem className="menu-nav" style={{ backgroundColor: 'black' }}>
                            <a onClick={handleContactUsNav} className="list-item">Contact Us</a>
                        </MenuItem>
                        <MenuItem className="menu-nav" style={{ backgroundColor: 'black' }}>
                            <a onClick={handleServecesNav} className="list-item">Our Services</a>
                        </MenuItem>
                        <MenuItem className="menu-nav" style={{ backgroundColor: 'black' }}>
                            {logged && <a onClick={loginRegister} className="list-item">Login</a>}
                            {!logged && <a onClick={loginRegister} className="list-item">Register</a>}
                        </MenuItem>
                    </Menu>
                </nav>}
            </header>}
        </div>
    );
}

export default Header;

/*{isTabletOrMobile && <header className="header-container-mobile">
                <div className="header-search">
                    <img src={Logo} alt="logo-img-mobile" className="logo"></img>
                    {auth === 1 && <button className="btn" onClick={handleLogout}><BiLogOut color="gray" size={32} /></button>}
                </div>
                {auth === 0 && <div className="title-container">
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline-primary" onClick={handleContactUsNav}>تواصل معنا</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline-primary" onClick={handleServecesNav}>خدماتنا</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '10px' }}>
                        {logged && <button className="btn btn-outline-primary" onClick={loginRegister}>تسجيل الدخول</button>}
                        {!logged && <button className="btn btn-outline-primary" onClick={loginRegister}>إنشاء حساب</button>}
                    </div>
                    <img src={LogoPic} alt="logoPic-img-mobile" className="logoPic-img-mobile"></img>
                    {/*auth === 0 &&<div className="language">
                        <div className="dropdown">
                            <a className="btn btn-secondary dropdown-toggle" href={arbLangLink} role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <MdTranslate/>
                            </a>

                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href={arbLangLink}>Arabic</a></li>
                                <li><a className="dropdown-item" href={engLangLink}>English</a></li>
                            </ul>
                        </div>
                    </div>*///}
{/*<div className="title">C l i n i c</div>*/ }
//</div>//}
{/*auth == 1 && !addDetailsContextt && <NavBar />*/ }
//</header>}*/